module.exports = __webpack_public_path__ + "IMG_1096.e52ffe299133157250aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wedding/andy_jeska/600x600/IMG_1096.jpg
// module id = ./src/assets/images/wedding/andy_jeska/600x600/IMG_1096.jpg
// module chunks = main